// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__12cAv","top":"styles_top__sDjKV","block":"styles_block__b5oYX","image":"styles_image__tuHcH"};